import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/sonner";
import "./i18n";

import Header from "./components/Header";
import ProtectedRoute from "./components/ProtectedRoute";
import SubscriptionGate from "./components/SubscriptionGate";
import AiAssistant from "./components/AiAssistant";
import TrialBanner from "./components/TrialBanner";
import AnalyticsHeartbeat from "./components/AnalyticsHeartbeat";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Convert from "./pages/Convert";
import PdfTools from "./pages/PdfTools";
import PdfMerge from "./pages/PdfMerge";
import PdfSplit from "./pages/PdfSplit";
import PdfExtract from "./pages/PdfExtract";
import PdfReorder from "./pages/PdfReorder";
import PdfSign from "./pages/PdfSign";
import PdfAnnotate from "./pages/PdfAnnotate";
import AiStudio from "./pages/AiStudio";
import NaturalCommand from "./pages/NaturalCommand";
import PdfOcr from "./pages/PdfOcr";
import PdfCompress from "./pages/PdfCompress";
import PdfProtect from "./pages/PdfProtect";
import PdfWatermark from "./pages/PdfWatermark";
import PdfRedact from "./pages/PdfRedact";
import ShareSign from "./pages/ShareSign";
import PublicSign from "./pages/PublicSign";
import Recipes from "./pages/Recipes";
import TranslateDocument from "./pages/TranslateDocument";
import Pricing from "./pages/Pricing";
import PaymentSuccess from "./pages/PaymentSuccess";
import Billing from "./pages/Billing";
import DocGen from "./pages/DocGen";
import Wizard from "./pages/Wizard";
import DocScan from "./pages/DocScan";
import AdminPayments from "./pages/AdminPayments";
import AdminLayout from "./pages/AdminLayout";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Header />
          <TrialBanner />
          <AnalyticsHeartbeat />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
            <Route path="/billing" element={<ProtectedRoute><Billing /></ProtectedRoute>} />
            <Route path="/admin" element={<AdminLayout />} />
            <Route path="/admin/users" element={<AdminLayout />} />
            <Route path="/admin/payments" element={<AdminLayout />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/tools/convert"
              element={
                <SubscriptionGate>
                  <Convert />
                </SubscriptionGate>
              }
            />
            <Route path="/tools/pdf" element={<PdfTools />} />
            <Route
              path="/tools/pdf/merge"
              element={
                <SubscriptionGate>
                  <PdfMerge />
                </SubscriptionGate>
              }
            />
            <Route
              path="/tools/pdf/split"
              element={
                <SubscriptionGate>
                  <PdfSplit />
                </SubscriptionGate>
              }
            />
            <Route
              path="/tools/pdf/extract"
              element={
                <SubscriptionGate>
                  <PdfExtract />
                </SubscriptionGate>
              }
            />
            <Route
              path="/tools/pdf/reorder"
              element={
                <SubscriptionGate>
                  <PdfReorder />
                </SubscriptionGate>
              }
            />
            <Route
              path="/tools/pdf/sign"
              element={
                <SubscriptionGate>
                  <PdfSign />
                </SubscriptionGate>
              }
            />
            <Route
              path="/tools/pdf/annotate"
              element={
                <SubscriptionGate>
                  <PdfAnnotate />
                </SubscriptionGate>
              }
            />
            <Route path="/tools/ai/studio" element={<SubscriptionGate><AiStudio /></SubscriptionGate>} />
            <Route path="/tools/ai/command" element={<SubscriptionGate><NaturalCommand /></SubscriptionGate>} />
            <Route path="/tools/pdf/ocr" element={<SubscriptionGate><PdfOcr /></SubscriptionGate>} />
            <Route path="/tools/pdf/compress" element={<SubscriptionGate><PdfCompress /></SubscriptionGate>} />
            <Route path="/tools/pdf/protect" element={<SubscriptionGate><PdfProtect /></SubscriptionGate>} />
            <Route path="/tools/pdf/watermark" element={<SubscriptionGate><PdfWatermark /></SubscriptionGate>} />
            <Route path="/tools/pdf/redact" element={<SubscriptionGate><PdfRedact /></SubscriptionGate>} />
            <Route path="/tools/share-sign" element={<SubscriptionGate><ShareSign /></SubscriptionGate>} />
            <Route path="/tools/recipes" element={<SubscriptionGate><Recipes /></SubscriptionGate>} />
            <Route path="/tools/translate" element={<SubscriptionGate><TranslateDocument /></SubscriptionGate>} />
            <Route path="/tools/docgen" element={<SubscriptionGate><DocGen /></SubscriptionGate>} />
            <Route path="/tools/docgen/wizard/:wid" element={<SubscriptionGate><Wizard /></SubscriptionGate>} />
            <Route path="/tools/scan" element={<SubscriptionGate><DocScan /></SubscriptionGate>} />
            <Route path="/sign/:token" element={<PublicSign />} />
          </Routes>
          <AiAssistant />
          <Toaster position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
